export default __webpack_public_path__ + "static/media/freq-active.22f4fa7b.svg";